import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const ChildrenSchoolAttendanceComparisonAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    const series = [
        {
            name: 'Presentes',
            data: chartData?.childrenSchoolAttendanceComparisonAnual?.map(item => item.attended)
        },
        {
            name: 'Diferença',
            data: chartData?.childrenSchoolAttendanceComparisonAnual?.map(item => item.difference)
        },
        {
            name: 'Total',
            data: chartData?.childrenSchoolAttendanceComparisonAnual?.map(item => item.total)
        }
    ];

    const categories = chartData?.childrenSchoolAttendanceComparisonAnual?.map(item => getYearLabel(item.ano));

    return (
        <SimpleBars
            title={'Comparação de Frequência Escolar (Anual)'}
            horizontal={false}
            stacked
            subtitles={categories}
            series={series}
            showDataLabels={false}
        />
    );
};
